// Fixed translation dictionary for standardized music terms.
// Covers Gandharva exam grades and course subjects — terms that never need
// admin input because they are standardized across all schools.
// Usage: translateCourseName(course, i18n.language)

const GRADES = {
  mr: {
    "Prarambhik":              "प्रारंभिक",
    "Praveshika Pratham":      "प्रवेशिका प्रथम",
    "Praveshika Purna":        "प्रवेशिका पूर्ण",
    "Madhyama Pratham":        "मध्यमा प्रथम",
    "Madhyama Purna":          "मध्यमा पूर्ण",
    "Visharad Pratham":        "विशारद प्रथम",
    "Visharad Purna":          "विशारद पूर्ण",
    "Sangeet Alankar Pratham": "संगीत अलंकार प्रथम",
    "Sangeet Alankar Purna":   "संगीत अलंकार पूर्ण",
  },
  hi: {
    "Prarambhik":              "प्रारंभिक",
    "Praveshika Pratham":      "प्रवेशिका प्रथम",
    "Praveshika Purna":        "प्रवेशिका पूर्ण",
    "Madhyama Pratham":        "मध्यमा प्रथम",
    "Madhyama Purna":          "मध्यमा पूर्ण",
    "Visharad Pratham":        "विशारद प्रथम",
    "Visharad Purna":          "विशारद पूर्ण",
    "Sangeet Alankar Pratham": "संगीत अलंकार प्रथम",
    "Sangeet Alankar Purna":   "संगीत अलंकार पूर्ण",
  },
};

const SUBJECTS = {
  mr: {
    "Vocal":       "स्वर",
    "Harmonium":   "हार्मोनियम",
    "Light Music": "सुगम संगीत",
    "Tabla":       "तबला",
    "Sitar":       "सितार",
    "Flute":       "बासरी",
  },
  hi: {
    "Vocal":       "स्वर",
    "Harmonium":   "हार्मोनियम",
    "Light Music": "सुगम संगीत",
    "Tabla":       "तबला",
    "Sitar":       "सितार",
    "Flute":       "बाँसुरी",
  },
};

export function translateGrade(name, lang) {
  if (!name || lang === "en") return name ?? "";
  return GRADES[lang]?.[name] ?? name;
}

export function translateSubject(subject, lang) {
  if (!subject || lang === "en") return subject ?? "";
  return SUBJECTS[lang]?.[subject] ?? subject;
}

export function translateCourseName(course, lang) {
  if (!course) return "";
  const subject = translateSubject(course.subject, lang);
  const grade   = translateGrade(course.name, lang);
  return subject ? `${subject} — ${grade}` : grade;
}
